<template>
    <div>
        <b-form-group class="app-input-file" :id="'fieldset-' + id" v-bind="$attrs">
            <template v-if="useLabel" v-slot:label>{{ labelStr }} <span v-if="isRequired" class="required"></span></template>
            <div v-if="isAllowEdit && !isUpdatable">
                <b-input-group>
                    <b-form-file
                        v-if="currentModel == null || isReupload"
                        v-bind="$attrs"
                        v-model="inputModel"
                        @change="setUploadFile"
                        placeholder="Choose a file or drop it here..."
                        drop-placeholder="Drop file here..."
                        ref="file-input"
                    ></b-form-file>
                    <b-form-input v-if="currentModel && !isReupload" size="sm" readonly="readonly" v-model="currentModel.originalFilename"></b-form-input>
                    <b-input-group-append v-if="currentModel && !isReupload">
                        <b-button variant="light" class="btn-download" size="sm" @click="downloadFile"><b-icon-download /></b-button>
                        <b-button variant="danger" class="btn-upload" size="sm" @click="reuploadFile"><b-icon-trash-fill /></b-button>
                    </b-input-group-append>
                    <b-form-invalid-feedback id="input-name-live-feedback">
                        {{ errorMessage }}
                    </b-form-invalid-feedback>
                </b-input-group>
            </div>
            <div :class="useLabel ? 'input-label-detail' : ''" v-else-if="isUpdatable">
                <span v-if="inputModel != null">{{ inputModel | isFileName }}</span>
                <span v-else-if="currentModel != null">{{ currentModel | isFileName }}</span>
                <span v-else>-</span>
                <span class="float-right">
                    <b-button v-if="(inputModel != null && inputModel != undefined) || (currentModel != null && currentModel != undefined)" variant="light" class="btn-download mr-1 btn-download-detail" size="sm" @click="downloadFile"><b-icon-download /></b-button>
                    <a  v-if="isAllowEdit" @click="onPopoverShow" :id="'popover-button-sync-' + groupId"><app-icon-edit /></a>
                </span>
            </div>
            <div v-else>
                <a href="javascript:void" @click="downloadFile">{{ currentModel != null ? currentModel.originalFilename : "" }}</a>
            </div>
        </b-form-group>
        <b-popover :show.sync="popoverShow" :target="'popover-button-sync-' + groupId" :title="label" placement="bottomleft">
            <b-input-group>
                <b-form-file
                    v-if="currentPopoverModel == null || isReupload"
                    class="go-to-top"
                    v-bind="$attrs"
                    v-model="popoverInputModel"
                    @change="setUploadPopoverFile"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                    ref="file-input"
                ></b-form-file>
                <b-form-input v-if="currentPopoverModel && !isReupload" size="sm" readonly="readonly" v-model="currentPopoverModel.originalFilename"></b-form-input>
                <b-input-group-append v-if="currentPopoverModel && !isReupload">
                    <b-button variant="light" class="btn-download" size="sm" @click="downloadPopoverFile"><b-icon-download /></b-button>
                    <b-button variant="danger" class="btn-upload" size="sm" @click="reuploadPopoverFile"><b-icon-trash-fill /></b-button>
                </b-input-group-append>
                <b-form-invalid-feedback id="input-name-live-feedback">
                    {{ errorMessage }}
                </b-form-invalid-feedback>
            </b-input-group>
            <div class="popover-action float-right mt-2 mb-1">
                <b-button @click="popoverShow = false" size="sm" class="btn-default-white">Cancel</b-button>
                <b-button @click="setPopoverUploadFile" size="sm" class="btn-default ml-2">Save</b-button>
            </div>
        </b-popover>
    </div>
</template>
<script>
import { saveAs } from 'file-saver';
export default {
    components: {},
    props: ["model", "id", "currentModel", "errorMessage", "isEditable", "isUpdatable", "maxFileSize", "label", "isRequired", "nolabel"],
    data() {
        return {
            labelStr: this.label,
            inputModel: this.model,
            inputErrorMessage: '',
            isReupload:false,
            groupId : "fieldset-fileupload-" + this.id,
            popoverShow: false,
            popoverInputModel: null,
            currentPopoverModel: this.currentModel
        }
    }, 
    methods: {
        setUploadFile(event) {
            if (event.target.files.length > 0) {
                let file = event.target.files[0];
                if (this.maxFileSize != null && this.maxFileSize != undefined) {
                    let fileSize = (file.size / 1048576).toFixed();
                    if (fileSize > this.maxFileSize) {
                        alert("Max Allowed File Size " + this.maxFileSize + " MB");
                        this.inputModel = null;
                        return;
                    }
                }
                this.inputModel = file;
                this.$emit('update:model', this.inputModel);
                this.$emit('change');
            }
        },
        async downloadFile() {
            if (this.currentModel != null) {
                let url = process.env.VUE_APP_API_URL + 'Attachment/download/' + this.currentModel.id;
                let fileName = this.currentModel.originalFilename;
                this.$http.get(url, {responseType: 'blob'}).then(response => {
                    if (response != null) {
                        saveAs(response.data, fileName);
                    }
                }).catch(error => {
                    this.$store.dispatch('addErrorMessageGlobal', error);
                    throw error;
                })
                
            }
        },
        reuploadFile() {
            this.isReupload = true;
            this.inputModel = null;
            this.$emit('update:model', this.inputModel);
            this.$emit('change', "reupload");
        },
        clearFiles() {
            if(this.$refs['file-input']){
                this.$refs['file-input'].reset()
            }
        },
        onPopoverShow() {
            this.popoverInputModel = this.inputModel;
            this.popoverShow = true;
        },
        setUploadPopoverFile(event) {
            if (event.target.files.length > 0) {
                let file = event.target.files[0];
                if (this.maxFileSize != null && this.maxFileSize != undefined) {
                    let fileSize = (file.size / 1048576).toFixed();
                    if (fileSize > this.maxFileSize) {
                        alert("Max Allowed File Size " + this.maxFileSize + " MB");
                        this.popoverInputModel = null;
                        return;
                    }
                }
                this.popoverInputModel = file;
                //this.$emit('update:model', this.popoverInputModel);
                //this.$emit('change');
            }
        },
        async downloadPopoverFile() {
            if (this.currentPopoverModel != null) {
                let url = process.env.VUE_APP_API_URL + 'Attachment/download/' + this.currentPopoverModel.id;
                let fileName = this.currentPopoverModel.originalFilename;
                this.$http.get(url, {responseType: 'blob'}).then(response => {
                    if (response != null) {
                        saveAs(response.data, fileName);
                    }
                }).catch(error => {
                    this.$store.dispatch('addErrorMessageGlobal', error);
                    throw error;
                })
                
            }
        },
        reuploadPopoverFile() {
            this.isReupload = true;
            this.popoverInputModel = null;
            this.$emit('update:model', this.popoverInputModel);
            this.$emit('change', "reupload");
        },
        setPopoverUploadFile() {
            this.inputModel = this.popoverInputModel;
            this.$emit('update:model', this.inputModel);
            this.$emit('change');
            this.popoverShow = false;
        }
    },
     computed : {
        isAllowEdit : {
            get: function() {
                if (this.isEditable != undefined) return this.isEditable;
                else return true;
            }
        },
        useLabel() {
            if (this.nolabel != null && this.nolabel != undefined && this.nolabel != '') {
                if (this.nolabel) return false;
            }
            return true;
        }
    },
    watch: {
        currentModel(newValue, oldValue) {
            this.isReupload = false;
        },
        model(newValue, oldValue) {
            if (newValue == null) {
                this.clearFiles();
            }
        }
    },
    filters: {
        isFileName: function (value) {
            if (value != null && value != "") {
                if (value instanceof File) {
                    return value.name;
                }
                else if (typeof value == "object") {
                    return value.originalFilename != null && value.originalFilename != undefined ? value.originalFilename : "-";
                }
                return value;
            } else {
                return "-";
            }
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .modal-dialog {
    height: 70vh;
    width: 60vh;
}
.input-group-text {
    font-size: 0.7rem !important;
}

.btn-open-camera {
    padding: 1px 6px !important;
}

.barcode-text {
    font-size: 2rem;
    text-align: center;
}

::v-deep .custom-file-input {
    z-index: 5 !important;
}

</style>